"use strict";

export default {
  async getTransaction({ commit }, payload) {
    const { api, page = 1, limit = 5, search = "" } = payload;

    try {
      const res = await api.get(
        `/transactions?page=${page}&limit=${limit}&search=${search}`
      );
      commit("setTransaction", res.data.data);
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async createTransaction(_, payload) {
    const { api, ...rest } = payload;

    try {
      const res = await api.post(`/transactions/create`, { ...rest });
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },
};
